import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=adc8f87c&scoped=true"
import script from "@/views/Groups/Groups.ts?vue&type=script&lang=ts&external"
export * from "@/views/Groups/Groups.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Groups/groups.scss?vue&type=style&index=0&id=adc8f87c&prod&lang=scss&scoped=true&external"
import style1 from "../Users/users.scss?vue&type=style&index=1&id=adc8f87c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc8f87c",
  null
  
)

export default component.exports